import { render, staticRenderFns } from "./SelectListTaxonomyChildren.vue?vue&type=template&id=10bd750a&"
import script from "./SelectListTaxonomyChildren.vue?vue&type=script&lang=js&"
export * from "./SelectListTaxonomyChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports